import { createSelector } from '@ngrx/store'
import { isDefinedNumber } from '../../utils/credit.utils'
import { selectCreditState } from '../credit.selectors'
import { selectCurrentClientID } from './../../../core/store/broker/broker.selectors'

const selectMetricsState = createSelector(selectCreditState, (state) => state.metrics)

export const selectMetricConfiguration = createSelector(
  selectMetricsState,
  (state) => state.metricConfiguration,
)

export const selectMetricConfigurationNames = createSelector(
  selectMetricsState,
  (state) => state.metricConfigurationNames,
)

export const selectCurrentMetricSettings = createSelector(
  selectMetricsState,
  (state) => state.metricConfiguration?.metricSettings,
)

export const isMetricsLoading = createSelector(selectMetricsState, (state) => state.isLoading)

export const isMetricsDirty = createSelector(selectMetricsState, (state) => state.isDirty)

export const isMetricsSaving = createSelector(selectMetricsState, (state) => state.isSaving)

export const isMetricsEditDisabled = createSelector(
  isMetricsDirty,
  selectMetricConfigurationNames,
  (isDirty, metricConfigurationNames) => isDirty || metricConfigurationNames.length < 1,
)

export const isMetricsCreateDisabled = createSelector(
  isMetricsDirty,
  selectCurrentClientID,
  (isDirty, clientId) => isDirty || !clientId,
)

const hasMetricConfigurationBeenSaved = createSelector(
  selectCurrentMetricSettings,
  (metricSettings) => metricSettings?.some((metricSetting) => isDefinedNumber(metricSetting.id)),
)

export const doesMetricConfigurationNameExist = createSelector(
  selectMetricConfiguration,
  selectMetricConfigurationNames,
  (metricConfiguration, metricConfigurationNames) =>
    metricConfigurationNames?.some((name) => name === metricConfiguration?.name),
)

export const isMetricsNameDisabled = createSelector(
  hasMetricConfigurationBeenSaved,
  (metricCongfigurationSaved) => metricCongfigurationSaved,
)

export const isMetricsNameInvalid = createSelector(
  hasMetricConfigurationBeenSaved,
  doesMetricConfigurationNameExist,
  (metricCongfigurationSaved, metricConfigurationNameExists) =>
    !metricCongfigurationSaved && metricConfigurationNameExists,
)

export const areAllMetricsEnabled = createSelector(
  selectCurrentMetricSettings,
  (metricSettings) =>
    metricSettings != null && metricSettings.length > 0 && metricSettings.every((m) => m.show),
)

export const isMetricsSaveDisabled = createSelector(
  isMetricsDirty,
  isMetricsNameInvalid,
  (isDirty, isMetricsNameInvalid) => !isDirty || isMetricsNameInvalid,
)

export const selectIsGse = createSelector(selectMetricsState, (state) => state.isGse)
